export default __webpack_public_path__ + "static/media/undraw_Bitcoin.59e38853.svg";